export class CreateArticleModel {
  constructor(
    public title: string,
    public content: string) {
  }
}
